import { useState, useEffect } from "react";
import ModalVideo from "react-modal-video";
import "react-modal-video/css/modal-video.css";
import { PlayButton } from "../../utils/defaultImages";

const ExerciseVideoDisplay = ({
  src,
  alt,
  width,
  height,
  className,
  exercisePlan = false,
  exerciseVideoUrl,
}) => {
  const [imageError, setImageError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(src);

  // Reset error state when src changes
  useEffect(() => {
    setImageError(false);
    setCurrentSrc(src);
  }, [src]);

  const handleImageClick = () => {
    if (exerciseVideoUrl) {
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Handle backdrop click (clicking outside the video)
  const handleBackdropClick = (e) => {
    // Only close if clicking on the backdrop itself, not on child elements
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Handle video container click to prevent closing when clicking on video controls
  const handleVideoContainerClick = (e) => {
    e.stopPropagation();
  };

  const imageSrc = imageError
    ? exercisePlan
      ? "/exerciseDefault.png"
      : "/MealOne.png"
    : currentSrc;

  return (
    <>
      <div className={`relative inline-block hover:opacity-80 ${
            exerciseVideoUrl
              ? "cursor-pointer hover:opacity-80"
              : "cursor-default"
          }`}>
        <img
          src={imageSrc}
          alt={alt}
          onError={() => setImageError(true)}
          onClick={handleImageClick}
          width={width}
          height={height}
          className={`${className} object-cover transition duration-300 `}
          loading="lazy"
          key={src}
        />

        {/* Play button overlay */}
        {exerciseVideoUrl && (
          <div
            className="absolute inset-0 flex items-center justify-center cursor-pointer"
            onClick={handleImageClick}
          >
            <div className="rounded-full p-2 flex items-center justify-center">
              <PlayButton />
            </div>
          </div>
        )}
      </div>

      {
        // Custom modal for Hyper Human videos
        isModalOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
            onClick={handleBackdropClick}
          >
            <div 
              className="relative w-full max-w-4xl mx-4"
              onClick={handleVideoContainerClick}
            >
              <button
                onClick={closeModal}
                className="absolute -top-10 right-0 bg-white text-black rounded-full w-8 h-8 flex items-center justify-center shadow-md hover:bg-gray-200 transition z-10"
                aria-label="Close video"
              >
                ✕
              </button>

              <div className="relative pt-[56.25%]">
                {" "}
                {/* 16:9 aspect ratio */}
                <video
                  controls
                  autoPlay
                  className="absolute top-0 left-0 w-full h-full rounded-lg"
                  src={exerciseVideoUrl}
                  onError={(e) => {
                    console.error("Video failed to load:", exerciseVideoUrl);
                    closeModal();
                  }}
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        )
      }
    </>
  );
};

export default ExerciseVideoDisplay;